import { useMemo } from 'react';

const TRACK = '#E6F4F1';
const FILL = '#119975';

export default function MedicalQuestionnaireProgressDonut({ percent, size = 52, strokeWidth = 4 }) {
  const r = useMemo(
    () => Math.max(4, (size - strokeWidth) / 2 - 1),
    [size, strokeWidth]
  );
  const c = 2 * Math.PI * r;
  const dashOffset = c * (1 - Math.min(100, Math.max(0, percent)) / 100);
  const half = size / 2;

  return (
    <div className="relative shrink-0" style={{ width: size, height: size }}>
      <svg
        width={size}
        height={size}
        className="shrink-0 -rotate-90"
        aria-hidden="true"
      >
        <circle
          cx={half}
          cy={half}
          r={r}
          fill="none"
          stroke={TRACK}
          strokeWidth={strokeWidth}
        />
        <circle
          cx={half}
          cy={half}
          r={r}
          fill="none"
          stroke={FILL}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={dashOffset}
        />
      </svg>
      <span
        className="pointer-events-none absolute inset-0 flex items-center justify-center font-semibold text-[#119975] font-poppins"
        style={{ fontSize: size <= 44 ? 11 : size <= 56 ? 13 : 15 }}
      >
        {percent}%
      </span>
    </div>
  );
}
